var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlossary = function SvgGlossary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#glossary_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "m20 35-.167-.25c-1.157-1.737-1.736-2.605-2.501-3.234a6.7 6.7 0 0 0-2.296-1.228C14.09 30 13.046 30 10.958 30H8.667c-1.867 0-2.8 0-3.513-.363a3.33 3.33 0 0 1-1.457-1.457c-.364-.713-.364-1.646-.364-3.513V10.333c0-1.867 0-2.8.364-3.513.32-.627.83-1.137 1.457-1.457C5.867 5 6.8 5 8.667 5h.667c3.733 0 5.6 0 7.026.727a6.67 6.67 0 0 1 2.913 2.913C20 10.066 20 11.933 20 15.667M20 35V15.667M20 35l.167-.25c1.158-1.737 1.736-2.605 2.501-3.234a6.7 6.7 0 0 1 2.296-1.228C25.911 30 26.955 30 29.042 30h2.291c1.867 0 2.8 0 3.514-.363a3.33 3.33 0 0 0 1.456-1.457c.364-.713.364-1.646.364-3.513V10.333c0-1.867 0-2.8-.364-3.513a3.33 3.33 0 0 0-1.456-1.457C34.134 5 33.2 5 31.333 5h-.666c-3.734 0-5.6 0-7.027.727a6.67 6.67 0 0 0-2.913 2.913C20 10.066 20 11.933 20 15.667"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossary_svg__a",
    x1: 33.709,
    x2: -30.968,
    y1: 5.828,
    y2: 33.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgGlossary;